import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// import InvoiceDownloadPage from 'src/components/trainings/InvoiceDownloadPage';
// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);

const TrainingTraineesView= lazy(() => import('src/pages/training/training-trainees-view'));
const TrainingShortEdition= lazy(() => import('src/pages/training/trainingShortEdition'));
const TrainingView = lazy(() => import('src/pages/training/training_view'));
const TrainingEdition = lazy(() => import('src/pages/training/trainingEdition'));
const NewModule = lazy(() => import('src/components/trainings/modules/newModule'));
const InvoiceDownloadPage = lazy(() => import('src/components/trainings/InvoiceDownloadPage'));
const InvoiceExportWordPage = lazy(() => import('src/components/trainings/InvoiceExportWordPage'));
const InvoiceEditView = lazy(() => import('src/components/trainings/invoice/view/invoice-edit-view'));
const InvoiceDetailsView = lazy(() => import('src/components/trainings/invoice/view/invoice-details-view'));



// ----------------------------------------------------------------------

export const TrainingsOrganizationRoutes = [
  {
    path: 'trainings',
    element: (
      <AuthGuard allowedRoles={['organization', 'manager']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <TrainingView />, index: true },
      { path: 'edition', element: <TrainingEdition /> },
      { path: 'module/edition', element: <NewModule /> },
      { path: 'invoices/edition', element: <InvoiceEditView /> },
      { path: 'invoices/details', element: <InvoiceDetailsView /> },
      { path: 'short/edition', element: <TrainingShortEdition /> },
    ],
  },
  {
    path: 'invoices/pdf/:id/trainees/:traineeID/sessions/:sessionID/types/:type',
    element: <InvoiceDownloadPage />
  },
  {
    path: 'invoices/word/:id/trainees/:traineeID/sessions/:sessionID/types/:type',
    element: <InvoiceExportWordPage />
  },
];

export const TrainingsParticipantRoutes = [
  {
    path: 'trainees/trainings',
    element: (
      <AuthGuard allowedRoles={['trainee']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <TrainingTraineesView />, index: true },
      { path: 'edition', element: <TrainingEdition /> },
      { path: 'module/edition', element: <NewModule /> },
      { path: 'invoices/details', element: <InvoiceDetailsView /> },
    ],
  },
 
]; 
